import { z } from "zod";
export const ControlledAiFailureResultV1Schema = z.object({
    schemaVersion: z.literal("controlled-ai-failure.v1.0"),
    requirementId: z.literal("AI-009"),
    ok: z.boolean(),
    humanContinuationRequired: z.boolean(),
    detail: z.string().optional(),
}).strict();
export function mapAiFailureContinuation(input) {
    const malformed = input.payload.trim().length === 0;
    return ControlledAiFailureResultV1Schema.parse({
        schemaVersion: "controlled-ai-failure.v1.0",
        requirementId: "AI-009",
        ok: !malformed,
        humanContinuationRequired: true,
        detail: malformed ? "malformed_or_low_confidence" : undefined,
    });
}
//# sourceMappingURL=failure.js.map